import React from 'react';
import './Algorithm.scss';
import { useSelector, useDispatch } from 'react-redux';
import { actionAlgorithmPanel, payloadAlgorithmPanel } from '../../../../Redux/Actions/Atlas/algorithmPanel.action'
import { RootState } from '../../../../Redux/Store/store';

const Algorithm = () => {
    const algorithmPanel: payloadAlgorithmPanel = useSelector((state: RootState) => state.algorithmPanelAtlas);
    const dispatch = useDispatch();
    const type = ['maxrect', 'tool'];
    return (
        <div className="algorithm-tab-container">
            <h3 className="noselect">Algorithm</h3>
            <div className="algorithm-tab-container--inputs">
                <span className="noselect">Type</span>
                <select value={algorithmPanel.type} onChange={(event) => dispatch(actionAlgorithmPanel({ ...algorithmPanel, type: event.target.value }))}>
                    <option value={type[0]}>MaxRect</option>
                    <option value={type[1]}>Tool</option>
                </select>
            </div>
            {
                (algorithmPanel.type === type[0]) ?
                    <div>
                        <div className="algorithm-tab-container--inputs">
                            <span className="noselect">Width (px)</span>
                            <input type="number" value={algorithmPanel.width} onChange={(event) => dispatch(actionAlgorithmPanel({ ...algorithmPanel, width: Math.round(Number(event.target.value)) }))} min={0} max={2000} />
                        </div>
                        <div className="algorithm-tab-container--inputs">
                            <span className="noselect">Height (px)</span>
                            <input type="number" value={algorithmPanel.height} onChange={(event) => dispatch(actionAlgorithmPanel({ ...algorithmPanel, height: Math.round(Number(event.target.value)) }))} min={0} max={2000} />
                        </div>
                    </div>
                    :
                    < div className="algorithm-tab-container--inputs">
                        <span className="noselect">Size (row)</span>
                        <input type="number" value={algorithmPanel.size} onChange={(event) => dispatch(actionAlgorithmPanel({ ...algorithmPanel, size: Math.round(Number(event.target.value)) }))} min={1} max={100} />
                    </div>
            }


            <div className="algorithm-tab-container--inputs">
                <span className="noselect">Extrusion (px)</span>
                <input type="number" value={algorithmPanel.extrusion} onChange={(event) => dispatch(actionAlgorithmPanel({ ...algorithmPanel, extrusion: Math.round(Number(event.target.value)) }))} min={0} max={10} />
            </div>
            {
                (algorithmPanel.type === type[0]) &&
                <div className="algorithm-tab-container--inputs">
                    <span className="noselect">Separation (px)</span>
                    <input type="number" value={algorithmPanel.separation} onChange={(event) => dispatch(actionAlgorithmPanel({ ...algorithmPanel, separation: Math.round(Number(event.target.value)) }))} min={0} max={10} />
                </div>
            }

        </div >
    )
}

export default Algorithm
